import { CmsArticle } from '@domgen/dgx-fe-cms';

export type CmsArticleSearchPage = CmsArticle<{
  brand?: {
    brandName: string;
    brandTermsAndConditionsSmallDomesticApplianceCare: string;
    brandTermsAndConditionsApplianceCare: string;
    brandAverageCallOut: string;
    name: string;
    brandPrivacyPolicy: string;
    brandIpidSmallDomesticApplianceCare: string;
  };
  category?: {
    name: string;
    title: string;
  };
  subcategory: {
    name: string;
    title: string;
  };
}>;
